'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ulid = exports.uuid = undefined;

var _isSafeInteger = require('babel-runtime/core-js/number/is-safe-integer');

var _isSafeInteger2 = _interopRequireDefault(_isSafeInteger);

exports.isValid = isValid;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uuid = exports.uuid = require('uuid/v4');

var _require = require('ulid'),
    ulid = _require.ulid;

exports.ulid = ulid;
function isValid(identifier) {
  if (!identifier) return false;

  return (0, _isSafeInteger2.default)(identifier) && identifier > 0 || /^[0-9A-Z]+$/i.test(identifier) || /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.test(identifier);
}

exports.default = {
  isValid: isValid,
  uuid: uuid,
  ulid: ulid
};